import * as Yup from 'yup';

import { GREATER_THAN, IN_BETWEEN, LESS_THAN_EQUALS_TO } from '../constants';

// Validation schema for each slab for ExternalPMRForm
export const validationSchema = Yup.object().shape({
  externalPMR: Yup.array().of(
    Yup.object()
      .shape({
        externalUpfrontTdr: Yup.number()
          .positive('TDR must be greater than 0')
          .max(100, 'TDR must be less than 100'),
        greaterThanValue: Yup.number().min(
          0,
          'Greater than must be greater than or equal to 0',
        ),
        lessThanEqualsToValue: Yup.number().min(
          0,
          'Less than equals to must be greater than or equal to 0',
        ),
        fixedFee: Yup.number().min(
          0,
          'Fixed Fee than must be greater than or equal to 0',
        ),
        floor: Yup.number().min(
          0,
          'Floor than must be greater than or equal to 0',
        ),
        ceil: Yup.number().min(0, 'Ceil must be greater than or equal to 0'),
      })
      .test('oneOfRequired', function validateConditionValue(value) {
        if (value.condition === IN_BETWEEN) {
          if (!value.greaterThanValue && !value.lessThanEqualsToValue) {
            return this.createError({
              path: `${this.path}.greaterThanValue`,
              message:
                'Either Greater than value or Less than equals to value is required',
            });
          }
        } else if (value.condition === GREATER_THAN) {
          if (!value.greaterThanValue) {
            return this.createError({
              path: `${this.path}.greaterThanValue`,
              message: 'This is a required field',
            });
          }
        } else if (value.condition === LESS_THAN_EQUALS_TO) {
          if (!value.lessThanEqualsToValue) {
            return this.createError({
              path: `${this.path}.lessThanEqualsToValue`,
              message: 'This is a required field',
            });
          }
        }
        return true;
      })
      .test('oneOfTdrOrFixedFeeRequired', function validateTDR(value) {
        if (!value.externalUpfrontTdr && !value.fixedFee) {
          return this.createError({
            path: `${this.path}.externalUpfrontTdr`,
            message: 'At least one of TDR or Fixed Fee is required',
          });
        }
        return true;
      })
      .test('validateFloorAndCeilRange', function validateFloorAndCeilRange(
        value,
      ) {
        if (typeof value.floor === 'number' && typeof value.ceil === 'number') {
          const { floor, ceil } = value;
          // If floor is greater than or equal to ceil
          if (floor >= ceil) {
            // Determine which path to return the error on and generate dynamic message
            const isFloorContext = this.path.includes('floor');
            const errorPath = isFloorContext
              ? `${this.path}`
              : `${this.path}.ceil`;
            const errorMessage = isFloorContext
              ? `Floor must be less than ${ceil}`
              : `Ceil must be more than ${floor}`;

            return this.createError({
              path: errorPath,
              message: errorMessage,
            });
          }
        }
        return true;
      })
      .test('validateInBetweenRange', function validateInBetweenRange(value) {
        if (value.condition === IN_BETWEEN) {
          const { greaterThanValue, lessThanEqualsToValue } = value;

          if (
            typeof greaterThanValue === 'number' &&
            typeof lessThanEqualsToValue === 'number'
          ) {
            // Determine which path to return the error on and generate dynamic message
            const isGreaterThanContext = this.path.includes('greaterThanValue');

            const errorPath = isGreaterThanContext
              ? `${this.path}`
              : `${this.path}.lessThanEqualsToValue`;

            const errorMessage = isGreaterThanContext
              ? `Greater than value must be less than ${lessThanEqualsToValue}`
              : `Less than equals to value must be more than ${greaterThanValue}`;

            // Check if greaterThanValue is less than lessThanEqualsToValue
            if (greaterThanValue >= lessThanEqualsToValue) {
              return this.createError({
                path: errorPath,
                message: errorMessage,
              });
            }
          }
        }
        return true;
      }),
  ),
});
